import { useWSModal } from "@wingspanhq/fe-component-library";
import { AddPayeeToEngagementModal } from "./index";

export function useAddPayeeToEngagementModal() {
  return useWSModal(AddPayeeToEngagementModal, {
    title: "Add contractor to engagement",
    size: "S"
  });
}
